import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { ScheduleQueries } from '@frontend/api-schedule';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { InfiniteQueryResult } from '@frontend/types';
import { DEFAULT_SCHEDULE_REQUEST_STATUSES_PARAM_V2 } from '../../../../../../constants';
import { useGetPendingRequestsV3InfiniteQuery } from './use-get-pending-requests-v3-infinite-query';

export const useGetScheduleRequestInfiniteListQuery = (
  locationId: string
): InfiniteQueryResult<Record<'rows', ScheduleRequest[]>> => {
  const { isScheduleV3FlagEnabled, isLoading: isLoadingFF } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const scheduleRequestListQuery = ScheduleQueries.useGetScheduleRequestListInfiniteQuery(
    {
      locationId,
      limit: 25,
      statuses: DEFAULT_SCHEDULE_REQUEST_STATUSES_PARAM_V2,
      orderBy: '-createdAt',
      offset: 0,
    },
    { enabled: !isLoadingFF && !isScheduleV3FlagEnabled }
  );

  const scheduleRequestListQueryV3 = useGetPendingRequestsV3InfiniteQuery([locationId]);

  return isScheduleV3FlagEnabled ? scheduleRequestListQueryV3 : scheduleRequestListQuery;
};
